import React, { useEffect, useState } from "react";
import { IListItemLinkProps, ListItemLink } from "../ListItemLink/ListItemLink";
import { useStyles } from "./Sidebar.styles";
import clsx from "clsx";
import { FormattedMessage, useIntl } from "react-intl";
import { Home, ExitToApp } from "@material-ui/icons";
import {
  List,
  ListSubheader,
  Drawer,
  IconButton,
  Grid,
  ListItem,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
} from "@material-ui/core";
import { Logo } from "../Logo/Logo";
import logo from "../../Assets/Images/aptor.svg";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import theme from "../../Theme/theme";
import { useMsal } from "@azure/msal-react";
import { useLocation } from "react-router-dom";
export interface ISidebarProps {
  title?: React.ReactNode;
  handleSidebarToggle: (show: boolean) => void;
  sidebarOpen: boolean;
  items?: IListItemLinkProps[];
}
const getInitialIndex = (currentPath: string, items?: IListItemLinkProps[]) => {
  if (!items) {
    return 0;
  } else {
    const matches = items
      .filter((x) => currentPath.indexOf(x.to) > -1)
      .sort((a, b) => (a.to.length > b.to.length ? -1 : 1));
    return matches.length === 0 ? 0 : items.indexOf(matches[0]);
  }
};
export const Sidebar: React.FC<ISidebarProps> = (props) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const { instance } = useMsal();
  const location = useLocation();
  const { title, handleSidebarToggle, sidebarOpen, items } = props;
  const [selectedIndex, setSelectedIndex] = useState<number>(
    getInitialIndex(location.pathname, props.items)
  );
  const isMobile = useMediaQuery((theme) =>
    (theme as any).breakpoints.down("md")
  );
  useEffect(() => {
    if (isMobile) {
      handleSidebarToggle(false);
    } else {
      handleSidebarToggle(true);
    }
  }, [isMobile, handleSidebarToggle]);
  const handleClick = (index: number) => {
    setSelectedIndex(index);
    if (isMobile) {
      handleSidebarToggle(false);
    }
  };
  const handleLogout = async () => {
    await instance.logoutRedirect();
    localStorage.clear();
  };
  useEffect(() => {
    setSelectedIndex(getInitialIndex(location.pathname, items));
  }, [location, items]);
  const sidebar = (
    <Grid
      className={clsx(classes.sidebar, { [classes.sidebarOpen]: sidebarOpen })}
      container
      direction="column"
      justifyContent="space-between"
    >
      <Grid item>
        <List component="nav" aria-label="sidebar navigation">
          {sidebarOpen && (
            <ListSubheader className={classes.title} component="span">
              {title}
            </ListSubheader>
          )}
          <ListItemLink
            to="/"
            text={formatMessage({
              id: "component.sidebar.start",
              defaultMessage: "Start",
            })}
            icon={<Home />}
            onClick={() => sessionStorage.clear()}
          />
          {items?.map((item, index) => (
            <ListItemLink
              key={index}
              to={item.to=='/ms/administrations'?item.to+'/user':item.to}
              text={item.text}
              selected={selectedIndex === index}
              icon={item.icon}
              onClick={() => handleClick(index)}
            />
          ))}
        </List>
        <ListItem button onClick={handleLogout}>
          <ListItemIcon>
            <ExitToApp />
          </ListItemIcon>
          <ListItemText>
            <FormattedMessage
              id="form.logout"
              defaultMessage="Log out"
              description="Label for Logout-button"
            />
          </ListItemText>
        </ListItem>
      </Grid>
      {sidebarOpen && (
        <Grid item>
          <Logo src={logo} alt="Aptor logo" disablePadding small />
        </Grid>
      )}
    </Grid>
  );
  return (
    <>
      <Drawer
        // classes={{ paper: classes.root }}
        variant="permanent"
        className={clsx(classes.root, {
          [classes.open]: sidebarOpen,
          [classes.close]: !sidebarOpen,
        })}
        classes={{
          paper: clsx({
            [classes.open]: sidebarOpen,
            [classes.close]: !sidebarOpen,
          }),
        }}
        open={sidebarOpen}
        onClose={() => handleSidebarToggle(false)}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={() => handleSidebarToggle(false)}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </div>
        {sidebar}
      </Drawer>
    </>
  );
};
